<template>
  <a-drawer
    title="产品对比"
    placement="right"
    :visible="visible"
    v-if="visible"
    @close="close"
    width="100%"
  >
    <a-row justify="space-between" type="flex" style="margin-bottom:10px">
      <div>
        价格来源：
        <a-radio-group v-model="form.priceSource" @change="getList">
          <a-radio v-for="item in priceOption" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-radio>
        </a-radio-group>
      </div>
      <a-radio-group v-model="form.priceDimension" @change="getList">
        <a-radio-button :value="1">
          历史价格
        </a-radio-button>
        <a-radio-button :value="0">
          最新价格
        </a-radio-button>
      </a-radio-group>
    </a-row>
    <a-table 
      bordered
      row-key="id"
      :pagination="false"
      :scroll="{x: 500,y}"
      :dataSource="list"
      :columns="columns"
    >
      <template slot="name" slot-scope="t">
        <a-tooltip>
          <template slot="title">{{ t }}</template>
          {{ t }}
        </a-tooltip>
      </template>
      <template slot="fixed" slot-scope="t,r,i">
        <span v-if="i > materialIndex && i < nutritionIndex">{{ t ? Number(t).toFixed(3) : t }}</span>
        <span v-else-if="i > nutritionIndex ">{{ t ? Number(t).toFixed(2) : t }}</span>
        <span v-else-if="i === nutritionIndex"></span>
        <span v-else>{{ t }}</span>
      </template>
    </a-table>
    <a-space style="text-align: right;padding-top: 10px;display: block;">
      <a-button type="primary" @click="openExport">导出</a-button>
    </a-space>
    <Export-Confirm :visible="exportVisible" @close="closeExport" :formData="form" :productIdList="productIdList" />
  </a-drawer>
</template>

<script>
import ExportConfirm from './ExportConfirm.vue'
export default {
  props: ['visible','productIdList'],
  components: {ExportConfirm},
  data() {
    return {
      cacheData: [],
      y: 500,
      form: {priceSource: 4,priceDimension: 1},
      priceOption: [
        { label: "市场价格", value: 4 },
        { label: "库存价格", value: 3 },
        { label: "合同价格", value: 1 },
        { label: "预测价格", value: 2 },
      ],
      exportVisible: false,
      materialIndex: 0,
      nutritionIndex: 0,
    }
  },
  computed: {
    // materialIndex(){
    //   let i = 0
    //   this.cacheData.forEach((el,index) => {
    //     if(el[0] === '原料') i = index
    //   })
    //   return i
    // },
    // nutritionIndex(){
    //   let i = 0
    //   this.cacheData.forEach((el,index) => {
    //     if(el[0] === '营养指标') i = index
    //   })
    //   return i
    // },
    list(){
      let lst = []
      let len = this.cacheData[0] ? this.cacheData[0].length : 0
      for(let i = 0;i < len; i++){
        let obj = {}
        this.cacheData && this.cacheData.forEach((el,ind) => {
          if(i !== 0) obj[`value${ind}`] = el[i]
        })
        if(obj.value0) lst.push(obj)
      }
      return lst
    },
    columns(){
      let lst = []
      let first = []
      this.cacheData.forEach(el => {
        first.push(el[0])
      })
      first.forEach((title,i) => {
        let obj = {
          dataIndex: `value${i}`,
          title,
          width: 120,
        }
        if(i === 0) {
          obj.fixed = 'left'
          obj.width = 160
          obj.ellipsis = true
          obj.scopedSlots = {customRender: 'name'}
        }
        if(i > 0) obj.scopedSlots = {customRender: 'fixed'}
        lst.push(obj)
      })
      return lst
    },
  },
  watch: {
    list: {
      handler(val) {
        val.forEach((el,index) => {
          if(el.value0 === '原料') this.materialIndex = index
          if(el.value0 === '营养指标') this.nutritionIndex = index
        })
      },
      deep: true,
    },
    visible(val){
      if(val){
        this.form = {
          priceSource: 4,priceDimension: 1
        }
        this.getList()
      }
    },
  },
  mounted(){
    this.y = document.body.clientHeight - 210
  },
  methods: {
    close(){
      this.$emit('close')
    },
    getList(){
      if(this.productIdList.length === 0) return
      let params = {
        productIdList: this.productIdList,
        ...this.form
      }
      this.$http.post('/nhf-app/formulaproductext/productListContrast',params).then(res => {
        let {success,data} = res || {}
        if(success) {
          this.cacheData = data
        }
      })
    },
    openExport(){
      this.exportVisible = true
    },
    closeExport() {
      this.exportVisible = false
    },
  }
}
</script>